<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">{{ 'activities.add_client' | translate }}</h2>
    </v-card-title>

    <v-card-content>
      <div class="form">
        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.first_name" :label="$t('base.first_name')" :hint="errorMessage('first_name')"
                :focus="true" :invalid="!!errorMessage('first_name')" @input="clearFieldError('first_name')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.phone" :label="$t('base.phone')" :hint="errorMessage('phone')"
                :invalid="!!errorMessage('phone')" @input="clearFieldError('phone')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.last_name" :label="$t('base.last_name')" :hint="errorMessage('last_name')"
                :invalid="!!errorMessage('last_name')" @input="clearFieldError('last_name')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.email" :label="$t('base.email')" :hint="errorMessage('email')"
                :invalid="!!errorMessage('email')" @input="clearFieldError('email')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.company_name" :label="$t('base.company_name')" :hint="errorMessage('company_name')"
                :invalid="!!errorMessage('company_name')" @input="clearFieldError('company_name')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.password" :label="$t('base.password')" type="password"
                :hint="errorMessage('password')" :invalid="!!errorMessage('password')"
                @input="clearFieldError('password')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-input-r v-model="form.profile.about" :label="$t('base.about_client')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <v-select-r v-model="form.profile.group" :options="countries" :label="$t('base.country')"
                :hint="errorMessage('group')" :invalid="!!errorMessage('group')" :loading="loadingCountries"
                item-text="name" item-value="id" @input="clearFieldError('group')" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-select-r item-value="key" :label="$t('base.select_lang')" :options="languages"
                v-model="form.profile.language" :hint="errorMessage('language')" :invalid="!!errorMessage('language')"
                @input="clearFieldError('language')" />
            </div>
          </div>
          <div class="form-column">
            <div class="form-element">
              <div class="access-switch">
                <span>{{ 'activities.access_kkz' | translate }}</span>
                <v-switch v-model="form.kkz" inset />
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-column">
            <div class="form-element">
              <v-card-actions class="justify-end">
                <v-btn color="green darken-1" dark @click="submit" :loading="loading">
                  {{ $t('base.save') }}
                </v-btn>
              </v-card-actions>
            </div>
          </div>

        </div>
      </div>
    </v-card-content>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'CreateClientModal',
  mixins: [formErrorsMixin],
  data () {
    return {
      loading: false,
      loadingCountries: false,

      form: {
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        phone: '',
        user_type: 'client',
        company_name: '',
        profile: {
          about: '',
          language: null,
          group: null,
        },
        profeed: true,
        kkz: true
      },
      errors: null,
      languages: [
        { id: 0, name: 'English', key: 'en' },
        { id: 1, name: 'Українська', key: 'uk' },
        { id: 2, name: 'Русский', key: 'ru' },
        { id: 3, name: 'Polish', key: 'pl' },
        { id: 4, name: 'Nederlands', key: 'nl' },
        { id: 5, name: 'Deutschland', key: 'de' },
        { id: 6, name: 'France', key: 'fr' },
        { id: 7, name: 'Italia', key: 'it' },
        { id: 8, name: 'România', key: 'ro' },
        { id: 9, name: 'USA', key: 'us' },
      ],
    }
  },
  computed: {
    ...mapGetters('countriesGroups', ['countriesGroups']),

    countries () {
      if (!this.countriesGroups.length) {
        return []
      }
      return this.countriesGroups.map(country => ({
        id: country.id,
        name: country.name
      }))
    }
  },
  async mounted () {
    await this.loadCountries()
  },
  methods: {
    ...mapActions('countriesGroups', ['loadCountriesGroups']),
    ...mapActions('dashboard', ['createUser']),

    async loadCountries () {
      this.loadingCountries = true
      try {
        await this.loadCountriesGroups()
        const ukraine = this.countries.find(c => c.name === 'Ukraine')
        if (ukraine && !this.form.profile.group) {
          this.form.profile.group = ukraine.id
        }
      } catch (error) {
        console.error('Помилка завантаження країн:', error)
      } finally {
        this.loadingCountries = false
      }
    },

    clearFieldError (fieldName) {
      if (this.errors && this.errors[fieldName]) {
        this.$set(this.errors, fieldName, null)
      }
    },

    validate () {
      this.errors = {}

      if (!this.form.first_name) {
        this.errors.first_name = ['3']
      }

      if (!this.form.last_name) {
        this.errors.last_name = ['3']
      }

      if (!this.form.phone) {
        this.errors.phone = ['3']
      }

      if (!this.form.email) {
        this.errors.email = ['3']
      }

      if (!this.form.company_name) {
        this.errors.company_name = ['3']
      }

      if (!this.form.password) {
        this.errors.password = ['3']
      } else if (this.form.password.length < 8) {
        this.errors.password = ['6', 8] // код для "мінімальна довжина" з лімітом 8
      }

      if (!this.form.profile.group) {
        this.errors.group = ['3']
      }

      if (!this.form.profile.language) {
        this.errors.language = ['3']
      }

      // Повертаємо true якщо немає помилок
      return Object.keys(this.errors).length === 0
    },

    async submit () {
      if (!this.validate()) return

      this.loading = true

      try {
        // Підготовка payload відповідно до API
        const payload = {
          email: this.form.email,
          password: this.form.password,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          phone: this.form.phone,
          is_active: true,
          user_type: this.form.user_type,
          display_name: this.form.company_name,
          profile: {
            about: this.form.profile.about,
            language: this.form.profile.language,
            group: this.form.profile.group
          },
          modules: []
        }

        // Додавання модулів залежно від вибраних доступів
        if (this.form.profeed) {
          payload.modules.push('profeed')
        }
        if (this.form.kkz) {
          payload.modules.push('animalfeed')
        }

        const errors = await this.createUser(payload)

        if (!errors) {
          this.$toasted.success('Клієнта успішно створено!')
          this.$emit('update')
          this.$emit('close')
        } else {
          this.errors = errors

          if (errors.email) {
            this.$toasted.error('Некоректний email!')
          } else if (errors.phone) {
            this.$toasted.error('Некоректний номер телефону!')
          } else if (errors.password) {
            this.$toasted.error('Некоректний пароль!')
          } else {
            this.$toasted.error('Сталася помилка при створенні клієнта!')
          }
        }
      } catch (err) {
        console.error('Помилка при збереженні:', err)
        this.$toasted.error('Помилка при збереженні')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-card__actions {
  padding: 0;
  width: 100%;
}

.v-card__actions .v-btn {
  width: 100%;
}

.v-card__content {
  margin-top: 2rem;
  border-top: .1rem solid #d7d7d7;
  padding: 2rem;
  padding-top: 4rem;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.form-row {
  display: flex;
  gap: 40px;
  width: 100%;
}

.form-column {
  flex: 1;
  min-width: 0;
}

.form-element {
  width: 100%;
}

.access-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>